export const ARCHIVED_MATCHES_ENTITY_KEY = 'archivedMatches';
export const MATCHES_ENTITY_KEY = 'matches';
export const MESSAGES_ENTITY_KEY = 'messages';
export const OFFERING_ENTITY_KEY = 'offerings';
export const PURCHASES_ENTITY_KEY = 'purchases';
export const PROFILE_ENTITY_KEY = 'profiles';
export const PAYWALLS_ENTITY_KEY = 'paywalls';
